export function getRecipeImageUrl(title: string, size: { w: number; h: number } = { w: 400, h: 300 }) {
  // Generate a food-themed placeholder using a working service
  const seed = encodeURIComponent(title.toLowerCase().replace(/[^a-z0-9]/g, ''))
  return `https://picsum.photos/seed/${seed}/${size.w}/${size.h}`
}

export function getRecipeFallbackImage(size: { w: number; h: number } = { w: 400, h: 300 }) {
  // Generic food placeholder
  return `https://picsum.photos/${size.w}/${size.h}?grayscale&blur=1`
}

export function maybeProxyImage(url?: string | null) {
  if (!url) return ''
  try {
    const u = String(url)
    if (u.startsWith('/')) return u
    if (/^https?:\/\//i.test(u)) return `/api/image?url=${encodeURIComponent(u)}`
    return u
  } catch {
    return ''
  }
}
